(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name trainingPrograms.controller:showTrainingSyncCtrl
     *
     * @description
     *
     */
    angular
        .module('trainingPrograms')
        .controller('showTrainingSyncCtrl', showTrainingSyncCtrl);

    function showTrainingSyncCtrl($uibModalInstance,modalParams) {
        var vm = this;
        vm.model={
          otherHubValidationResponses : modalParams.syncResponses.otherHubValidationResponsesList|| [],
          syncResponses : getOtherHubSyncResponses(modalParams.syncResponses) || []
        }

        vm.closeMe = function(){
            $uibModalInstance.close();
        };
    }

    function getOtherHubSyncResponses(response){

      for (var key in response.otherHubSyncResponses) {
        if (response.otherHubSyncResponses.hasOwnProperty(key)) {
          if (response.otherHubSyncResponses[key]) {
            MessageService.success('Tenant: ' + key + ', Status: SUCCESS');
          } else {
            MessageService.warning('Tenant: ' + key + ', Status: FAILED');
          }
        }
      }

    }

}());
